import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddCategory.css";
import {
  createCategory,
  uploadImageApi,
} from "../../../../services/Category/category.service";

import { getAllDesireds } from "../../../../services/DesiredType/DesiredType.service";

import { toast } from "react-toastify";

interface AddCategoryProps {
  onClose?: () => void;
  onSuccess?: () => void;
}

interface MetalType {
  id: number;
  name: string;
}

const AddCategory: React.FC<AddCategoryProps> = ({
  onClose,
  onSuccess,
}) => {
  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [metalTypeId, setMetalTypeId] = useState("");

  const [metalTypes, setMetalTypes] = useState<MetalType[]>([]);

  const [imageFile, setImageFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);

  const [status, setStatus] = useState("ACTIVE");
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  // ✅ Get Metal Types
  useEffect(() => {
    fetchMetalTypes();
  }, []);

  const fetchMetalTypes = async () => {
    try {
      const response = await getAllDesireds();

      setMetalTypes(response.data || []);
    } catch (error) {
      console.error("Metal type fetch failed", error);
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate("/category/list");
    }
  };

  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0] || null;

    if (file) {
      setImageFile(file);

      const reader = new FileReader();

      reader.onloadend = () => {
        setPreview(reader.result as string);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!categoryName.trim()) {
      toast.error("Category name is required");
      return;
    }

    if (!metalTypeId) {
      toast.error("Please select metal type");
      return;
    }

    try {
      setSubmitting(true);

      if (imageFile) {
        await uploadImageApi(imageFile);
      }

      await createCategory({
        name: categoryName,
        description,
        status,
        metalTypeId,
        image: imageFile,
      });

      toast.success("Category added successfully");

      onSuccess?.();

      handleClose();
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message || error?.message || "Failed to create category";
      toast.error(errorMsg);

    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="add-category-container">
      <button
        type="button"
        className="close-btn"
        aria-label="Close"
        onClick={handleClose}
      >
        &times;
      </button>

      <h2>Add Category</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Category Name"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          required
        />

        {/* ✅ Metal Type Dropdown */}
        <select
          value={metalTypeId}
          onChange={(e) => setMetalTypeId(e.target.value)}
          required
        >
          <option value="">Select Metal Type</option>

          {metalTypes.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <div className="image-upload-box">
          {preview ? (
            <img
              src={preview}
              alt="Preview"
              className="preview-image"
            />
          ) : (
            <span>Click to upload image</span>
          )}

          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>

        <button type="submit" disabled={submitting}>
          {submitting ? "Adding..." : "Add Category"}
        </button>
      </form>
    </div>
  );
};

export default AddCategory;